import axios from "axios";

export default {
    namespaced: true,
    state: {
        products:[],
        product_info:{}
    },
    getters:{
        products(state){
            return state.products
        },
        product_info(state){
            return state.product_info
        }
    },  
    mutations:{
        SET_PRODUCT_LIST (state, payload) {
            state.products = payload
        },
        SET_PRODUCT_INFO (state, payload) {
            state.product_info = payload
        }
    },
    actions:{
       async getProductList(context,param){
        const response = await axios.get('/api/products',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){

                context.commit('SET_PRODUCT_LIST',response.data.data)
            }
       }
    }
}